// eslint-disable-next-line import/prefer-default-export
export { saveSelectedLocation } from './storeLocation';
